import { ScheduleColumn } from "@app/core/schedule/schedule-column";

export class ScheduleLayout {
  columns: ScheduleColumn[];
  groupings: any;
  filters: any;
  sorters: any;
  groupers: any;
  mapWidth: number;
  activeOnly: boolean;
}
